"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRestoreFootprintWithLedgerKeys = isRestoreFootprintWithLedgerKeys;
exports.isRestoreFootprintWithRestorePreamble = isRestoreFootprintWithRestorePreamble;
function isRestoreFootprintWithLedgerKeys(args) {
    return 'keys' in args;
}
function isRestoreFootprintWithRestorePreamble(args) {
    return 'restorePreamble' in args;
}
